
import recipe from '~/graphql/queries/recipe';
import meta from '~/plugins/mixins/meta';
import upsertRating from '~/graphql/mutations/upsertRating';

export default {
  auth: false,
  mixins: [meta],
  apollo: {
    recept: {
      query: recipe,
      prefetch: ({route}) => ({slug: route.params.slug}),
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({data: {recept}}) {
        if (!recept) {
          this.$nuxt.error({statusCode: 404, message: 'Recept niet gevonden'});
        }
      },
    },
  },
  data: () => ({
    selectedStar: false,
    givenRating: null,
    loading: false,
    recept: {},
  }),
  computed: {
    headerImage() {
      if (this.recept.beeld.length) {
        return this.recept.beeld[0].url;
      }

      if (this.recept.image) {
        return this.recept.image.url;
      }

      return null;
    },
  },
  created() {
    if (this.$auth.loggedIn) {
      const rating = this.$auth.user.ratings.filter(
        rating => rating.recipe_slug === this.$route.params.slug,
      );

      this.givenRating = rating[0] ? rating[0].rating : 0;
    }
  },
  methods: {
    async upsertRating(rating) {
      this.loading = true;
      try {
        const {data} = await this.$apollo.mutate({
          mutation: upsertRating,
          variables: {recipe_slug: this.$route.params.slug, rating},
        });
        this.givenRating = data.upsertRating.rating;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
  head() {
    return this.getMeta(this.recept);
  },
};
